module.exports = __webpack_public_path__ + "static/media/arrow-alt-to-left.eb10a551.svg";